import type { ViteEnvironmentClient } from "@core/data/infrastructures/vite-environment-client";
import { coreTypes } from "@iot-platform/core";
import { configure } from "mobx";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { container } from "./di/inversify.config";
import "./i18n.ts";
import "./index.css";
import { router } from "./routes/router.tsx";

const env = container.get<ViteEnvironmentClient>(
    coreTypes.infrastructure.EnvironmentClient,
);

if (env.mockApiEnabled && env.isDevelopment) {
    try {
        const { worker } = await import("./mocks/browser");

        await worker.start({
            onUnhandledRequest: ({ url }, print) => {
                // If the request URL is an API route, print a warning if not mocked.
                if (url.includes(`${env.apiServerUrl}${env.apiBaseUrl}`)) {
                    print.warning();
                }
            },
        });
    } catch (error) {
        console.error(error);
    }
}

if (env.isProduction) {
    const TagManager = (await import("@sooro-io/react-gtm-module")).default;
    TagManager.initialize({ gtmId: env.gtmId });
}

configure({
    computedRequiresReaction: true,
    enforceActions: "always",
    observableRequiresReaction: true,
});

const rootElement = document.getElementById("root");

if (!rootElement) {
    throw new Error('Unable to mount the app: no element with id "root".');
}

createRoot(rootElement).render(
    <StrictMode>
        <RouterProvider router={router} />
    </StrictMode>,
);
